export default __webpack_public_path__ + "static/media/ui_icon_comment_send.c070deb7.svg";